
import jsPDF from 'jspdf';
import { AnalysisSection } from '@/components/personality/enhanced-analysis/types';
import { PDF_CONFIG } from './pdf/constants';
import { addHeader, addMetadataSection, addIntroduction, addFooters } from './pdf/headerFooter';
import { generateSectionContent } from './pdf/contentGenerator';

interface PDFGenerationOptions {
  sections: AnalysisSection[];
  insightId: string;
  createdAt: string;
  userProfile?: {
    name?: string;
    email?: string;
  };
}

export const generateUltraDetailedPDF = async (options: PDFGenerationOptions): Promise<void> => {
  const { sections, insightId, createdAt, userProfile } = options;
  
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = PDF_CONFIG.margin;

  // Add cover page with header
  let yPosition = addHeader(pdf, pageWidth, margin);

  // Add metadata section
  yPosition = addMetadataSection(pdf, pageWidth, margin, yPosition, insightId, createdAt, userProfile);

  // Add introduction
  yPosition = addIntroduction(pdf, pageWidth, margin, yPosition);

  // Generate main content
  generateSectionContent(pdf, sections, pageWidth, pageHeight, margin, yPosition);

  // Add footers to all pages
  addFooters(pdf, pageWidth, pageHeight, margin);

  // Download the PDF
  const fileName = `relatorio-personalidade-${new Date().toISOString().split('T')[0]}.pdf`;
  pdf.save(fileName);
};
